import { Campaign } from '@ms/yammer-data/dist/state/types';

type CampaignUrl = (id: Campaign['id']) => string;
export const campaignUrl: CampaignUrl = (campaignId) => `/campaigns/${campaignId}`;
